import React from 'react';
import { map } from 'lodash';
import target from '../../../../../images/verizon/email_app/progress/target.webp';
import hands from '../../../../../images/verizon/email_app/progress/hands.png';
import heroDesktop from '../../../../../images/verizon/email_app/progress/hero-desktop.webp';
import heroMobile from '../../../../../images/verizon/email_app/progress/hero-mobile.webp';
import thanksDesktop from '../../../../../images/verizon/email_app/progress/thanks-desktop.webp';
import thanksMobile from '../../../../../images/verizon/email_app/progress/thanks-mobile.webp';
import ProgressHeader from './components/progressHeader';
import ProgressFooter from './components/progressFooter';

const checklist = [
  'Download the My Verizon App and register your account. Access account details at any time',
  'Save $10/mo when you add your payment method and enroll in Auto Pay',
  'Enroll in Verizon Loyalty for money back, epic experiences and incredible deals',
  'Add perks and save on subscriptions for entertainment and more',
  'Add Verizon Mobile Protect to protect your phone'
];

// BUZZ-3479: "Day 1 Onboarding" email. Cells 1-3 differ only by the
// `variant.topBanner` and `variant.thanksBlock` flags from data.js.
const VerizonProgressOnboarding = ({ emailData }) => {
  const { receiver, variant = {} } = emailData;

  return (
    <div className="email email-progress">
      <ProgressHeader />

      {
        variant.topBanner &&
        <div className="email-progress_top-banner">
          We’re glad you chose us to keep you connected
        </div>
      }

      {/* The red card is cropped from the client PDFs (720 = desktop, 360 = mobile) to keep the
          Verizon typography; the <picture> swaps them at the mobile breakpoint (768px).
          BUZZ-3481: the crop stops above the last line, which is HTML so it can be bigger and bold. */}
      <div className="email-progress_hero">
        <picture>
          <source media="(max-width: 768px)" srcSet={ heroMobile } />
          <img
            className="email-progress_hero-image"
            src={ heroDesktop }
            alt="Now let’s help you get more from Verizon."
          />
        </picture>
        <div className="email-progress_hero-text">
          Unlock discounts, monthly savings
          { ' ' }
          <span className="email-progress_hero-nowrap">and protection.</span>
        </div>
      </div>

      <div className="email-progress_section">
        <div className="email-progress_check">
          {/* placed before the text so it can float at the title's level on mobile */}
          <img className="email-progress_check-image" src={ target } alt="" />
          <div className="email-progress_check-content">
            <h2 className="email-progress_check-title">
              Check <span className="email-progress_check-title-break">your progress</span>
            </h2>
            <p className="email-progress_check-text">
              As a thank you for choosing us, start enjoying these benefits
              { ' ' }
              <span className="email-progress_check-nowrap">
                today
                { ' ' }
                <img className="email-progress_check-emoji" src={ hands } alt="" />
              </span>
            </p>
          </div>
        </div>

        <div className="email-progress_bar">
          <div className="email-progress_bar-fill" />
        </div>

        <ul className="email-progress_list">
          {
            map(checklist, (text) => (
              <li key={ text } className="email-progress_list-item">
                <span className="email-progress_list-text">{ text }</span>
                <svg className="email-progress_list-arrow">
                  <use xlinkHref="#svg_arrow-right" />
                </svg>
              </li>
            ))
          }
        </ul>
      </div>

      <div className="email-progress_section">
        <div className="email-progress_support">
          <div className="email-progress_support-main">
            <div className="email-progress_support-title">
              Get support
              <span className="email-progress_support-subtitle">when you need it too</span>
            </div>
            <div className="email-progress_support-text -mobile">
              Our technicians can assist with network issues, device problems and more.
            </div>
            <div className="email-progress_button">Find help</div>
          </div>
          <div className="email-progress_support-text -desktop">
            Our technicians can assist with network issues, device problems and more.
          </div>
        </div>
      </div>

      {
        variant.thanksBlock &&
        <div className="email-progress_section">
          {/* Cropped from the Cell 2 PDFs like the hero; <picture> swaps desktop/mobile at 768px. */}
          <picture className="email-progress_thanks">
            <source media="(max-width: 768px)" srcSet={ thanksMobile } />
            <img
              className="email-progress_thanks-image"
              src={ thanksDesktop }
              alt="Thanks for letting us keep you connected"
            />
          </picture>
        </div>
      }

      <div className="email-progress_divider" />

      <ProgressFooter receiver={ receiver }>
        <p className="email-progress_footer-text -black"><b>Account number ending in: XXXX</b></p>
        <p><b>My Verizon app: Data usage applies when downloading.</b></p>
        <p>
          <b>
            Verizon Mobile Protect: Limitations and exclusions apply. For full program details,
            { ' ' }
            refer to the appropriate device protection brochure.
          </b>
        </p>
        <p>
          <b>
            Verizon Dollars are available only to Verizon postpaid mobile, 5G Home Internet, or
            { ' ' }
            Verizon Home Internet Lite consumers. Verizon Shine is available only to Verizon postpaid
            { ' ' }
            mobile or Verizon Home Internet consumers.
          </b>
        </p>
        <p><b>*When you enroll in Verizon Loyalty.</b></p>
        <p>
          Activation/upgrade fee/line: $40 (waived when you enroll in Verizon Loyalty w/in 30 days of
          { ' ' }
          activation/upgrade). <b>IMPORTANT CONSUMER INFORMATION:</b> Subject to VZ Agmts, Calling Plan,
          { ' ' }
          & credit approval. Coverage, varying by svc, not available everywhere; see
          { ' ' }
          <span className="pseudo-link">verizon.com</span>. Restocking fee may apply. In MA & NV: Sales tax
          { ' ' }
          based on higher of device price or VZ’s device cost. In CA: Sales tax based on full price of
          { ' ' }
          device. Limited time offer; offer subject to change.
        </p>
      </ProgressFooter>
    </div>
  );
};

export default VerizonProgressOnboarding;
